import React, { useEffect, useState } from "react";
import TopNavbar from "../topNavbar/TopNavbar";
import Sidebar from "../sidebar/Sidebar";
import { Card, Col, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";
import * as icons from "react-bootstrap-icons";
import { Footer } from "../../Footer";
import {
  PlayerGetById,
  UploadImage,
  WebAdminProfile,
  ManagerGetById,
  GetSubScription,
} from "../../redux/auth-reducer/auth-service";
import { ImageUrl } from "../../utils/config/config";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-number-input";
import { DatePicker, Loader } from "rsuite";
import flags from "react-phone-number-input/flags";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import dayjs from "dayjs";

export const Profile = () => {
  const [data, setData] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);
  const [dataImage, setDataImage] = useState();
  const [showImage, setShowImage] = useState(false);
  const [validated, setValidated] = useState(false);
  const [imageName, setImageName] = useState("");
  const [userData, setUserData] = useState();
  const [countryIDName, setCountryIDName] = useState("");
  const [stateIDName, setStateIDName] = useState("");
  const [cityIDName, setCityIDName] = useState("");
  const [errorMessageImage, setErrorMessageImage] = useState(false);
  const [countryCode, setCountryCode] = useState("");
  const [inputDate, setInputDate] = useState();
  const [dateBirth, setDateBirth] = useState();
  const [dataSubscription, setDataSubscription] = useState();

  const [regForm, setRegForm] = useState({
    userImage: "",
    firstName: "",
    lastName: "",
    dateOfBirth: "",
    gender: "",
    phoneNumber: "",
    countryCode: "",
    emailId: "",
    address: "",
    country: "",
    state: "",
    city: "",
    zipCode: "",
  });

  const navigate = useNavigate();

  // Toggle sidebar state
  function sidebarfun() {
    setData(!data);
  }

  // Dedicated loading state for profile data
  useEffect(() => {
    const isRole = localStorage.getItem("role");
    const isUser = JSON.parse(localStorage.getItem("isUser"));
    const userId = isUser?.userId;

    const fetchUserData = async () => {
      try {
        if (
          isRole === "Web Admin" ||
          isRole === "Manager" ||
          isRole === "Admin"
        ) {
          const res = await ManagerGetById();
          setUserData(res?.data?.userImage);
          setCountryIDName(res?.data?.country);
          setStateIDName(res?.data?.state);
          setCityIDName(res?.data?.city);
          setRegForm(res?.data);
        } else if (isRole === "Player") {
          const res = await PlayerGetById(userId);
          setUserData(res?.data?.userImage);
          setCountryIDName(res?.data?.country);
          setStateIDName(res?.data?.state);
          setCityIDName(res?.data?.city);
          setRegForm(res?.data);
        }
      } catch (error) {
        toast.error("Failed to load profile data");
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setValidated(true);

    if (regForm?.dateOfBirth === "") {
      alert("Date of Birth is required.");
      return;
    }

    if (regForm?.userImage === "") {
      toast.error("Please upload an image.");
      return;
    }

    try {
      const dataList = [
        {
          userImage: dataImage || regForm?.userImage,
          firstName: regForm?.firstName,
          lastName: regForm?.lastName,
          DateOfBirth: regForm.dateOfBirth,
          gender: regForm.gender,
          phoneNumber: regForm.phoneNumber,
          emailId: userData?.emailId,
          address: regForm.address,
          countryCode: regForm.countryCode,
          country: location?.country || countryIDName,
          state: location?.["places"]?.[0]?.state || stateIDName,
          city: location?.["places"]?.[0]?.["place name"] || cityIDName,
          zipCode: regForm.zipCode || null,
          isPlayer: false,
        },
      ];

      const res = await WebAdminProfile(dataList);
      if (res?.status) {
        setValidated(false);
        toast.success(res?.message, { toastId: "success12" });
        // Now update localStorage so that TopNavbar reflects the updated name/image
        const isUser = JSON.parse(localStorage.getItem("isUser"));
        const updatedUser = {
          ...isUser,
          fullName: `${regForm.firstName} ${regForm.lastName}`,
          userImage: imageName ? dataImage : regForm.userImage,
        };
        localStorage.setItem("isUser", JSON.stringify(updatedUser));
      } else {
        toast.error(res?.message, { toastId: "error12" });
      }
    } catch (error) {
      toast.error(error?.message);
    }
  };

  const handleFileChange = (event) => {
    setErrorMessageImage(false);
    const file = event.target.files[0];
    setSelectedImage(URL.createObjectURL(file));
    setImageName(file.name);
    const imageAPI = async () => {
      const formDataImage = new FormData();
      formDataImage.append("file", file);
      const res = await UploadImage(formDataImage);
      if (res?.data?.status) {
        setDataImage(res?.data?.message);
        setShowImage(true);
      } else {
        toast.error(res?.message);
      }
    };
    imageAPI();
  };

  const isUserLocal = JSON.parse(localStorage.getItem("isUser"));
  const isRole = localStorage.getItem("role");

  useEffect(() => {
    if (regForm?.dateOfBirth) {
      setDateBirth(new Date(regForm.dateOfBirth));
    }
  }, [regForm]);

  const handelGender = (e) => {
    setRegForm({
      ...regForm,
      [e.target.name]: e.target.value,
    });
  };

  const handelform = (e) => {
    let value = e.target.value;
    if (e.target.name === 'firstName' || e.target.name === 'lastName') {
      // value = value.replace(/[^a-zA-Z\s]/g, '').slice(0, 30);
      value = value.slice(0, 30);
    }
    setRegForm({
      ...regForm,
      [e.target.name]: value,
    });
  };

  const handelPhone = (e) => {
    setRegForm({
      ...regForm,
      phoneNumber: e,
    });
  };

  const handelDate = (e) => {
    setRegForm({
      ...regForm,
      dateOfBirth: new Date(e).toISOString().slice(0, 19),
    });
    setInputDate(e);
  };

  const shouldDisableDate = (date) => {
    return (
      date > new Date(new Date().setFullYear(new Date().getFullYear() - 18))
    );
  };

  const cancelbtn = () => {
    navigate(-1);
  };

  const handleKeypress = (e) => {
    const characterCode = e.key;
    if (characterCode === "Backspace") return;
    const characterNumber = Number(characterCode);
    if (characterNumber >= 0 && characterNumber <= 9) {
      if (!e.currentTarget.value || e.currentTarget.value.length === 0) {
        if (characterNumber === 0) {
          e.preventDefault();
        }
      }
    } else {
      e.preventDefault();
    }
  };

  const [location, setLocation] = useState(null);
  const [error, setError] = useState("");

  const handelZipCode = async (e) => {
    const zipCode = e.target.value;
    setRegForm({
      ...regForm,
      [e.target.name]: zipCode,
    });

    if (zipCode.length === 5) {
      try {
        const response = await fetch(`https://api.zippopotam.us/us/${zipCode}`);
        if (!response.ok) {
          throw new Error("Zip code not found");
        }
        const data = await response.json();
        setLocation(data);
        setError("");
      } catch (err) {
        setError(err.message);
        setLocation(null);
      }
    }
  };

  useEffect(() => {
    if (regForm.countryCode) {
      setCountryCode(`+${regForm.countryCode}`);
    }
  }, [regForm.countryCode]);

  const handelPhoneCountryCode = (e) => {
    const newCountryCode = e?.replace("+", "");
    setCountryCode(`+${newCountryCode}`);
    setRegForm((prevForm) => ({
      ...prevForm,
      countryCode: newCountryCode,
    }));
  };

  const phoneNumber = parsePhoneNumberFromString(
    String(regForm?.phoneNumber),
    "US"
  );
  const formattedNumber = phoneNumber
    ? phoneNumber.formatNational()
    : regForm?.phoneNumber;

  useEffect(() => {
    const GetBySubscriptionFn = async () => {
      setLoading(true);
      try {
        const response = await GetSubScription();
        const data = response?.data?.data;

        // Check if data exists and has entries
        if (data && data.length > 0) {
          setLoading(false);
          // Get the last entry
          const lastEntry = data[data.length - 1];
          setDataSubscription(lastEntry);
        }
      } catch (error) {
        console.error("Error fetching subscription data:", error);
      }
    };

    GetBySubscriptionFn();
  }, []);

  // Determine subscription status
  const isSubscriptionActive = () => {
    if (isRole !== "Player") {
      return true; // Bypass subscription check for non-Player roles
    }

    if (!dataSubscription || !dataSubscription.subscriptionEndDate) {
      return false; // No subscription or no end date for Player
    }

    const currentDateTime = dayjs();
    const subscriptionEndDate = dayjs(
      dataSubscription.subscriptionEndDate + "Z"
    );
    return subscriptionEndDate.isAfter(currentDateTime); // Active if end date is in the future
  };

  return (
    <>
      <TopNavbar sidebarfun={sidebarfun} />
      <div className="dasboard-group">
        <Sidebar data={data} />
        <div
          className={
            data ? "dashboard-content full-contnet" : "dashboard-content"
          }
        >
          <Row>
            <Col md={6}>
              <h1 className="heading-dash">Profile</h1>
            </Col>
            <Col md={6} className="text-right">
              {loading ? (
                ""
              ) : isRole === "Player" ? (
                isSubscriptionActive() ? (
                  <Button href="/Player/Account_settings" variant="success">
                    Active
                  </Button>
                ) : (
                  <Button href="/Player/Account_settings" variant="danger">
                    Inactive
                  </Button>
                )
              ) : null}
            </Col>
          </Row>
          <Card className="p-5 profile-sec">
            {loading ? (
              <Loader />
            ) : (
              <Form
                noValidate
                validated={validated}
                onSubmit={handleSubmit}
                onKeyPress={(e) => {
                  if (e.key === "Enter") e.preventDefault();
                }}
              >
                <Row>
                  <Col md={4} lg="4">
                    <div className="text-center editprofileimage">
                      {!showImage ? (
                        <div>
                          {userData == null ? (
                            <img
                              src="../image/profileDefault.png"
                              alt="default profile"
                            />
                          ) : (
                            <img src={ImageUrl + userData} alt="profile" />
                          )}
                          <label
                            htmlFor="file"
                            className="editprofileicon"
                            name="file"
                            onChange={handleFileChange}
                          >
                            <icons.Pencil />
                            <Form.Control
                              type="file"
                              id="file"
                              multiple=""
                              data-original-title="upload photos"
                              required
                            />
                            {regForm?.userImage === "" && (
                              <Form.Control.Feedback
                                className="image-upload-update"
                                type="invalid"
                              >
                                Please upload image.
                              </Form.Control.Feedback>
                            )}
                          </label>
                        </div>
                      ) : (
                        <div>
                          {selectedImage && (
                            <img src={selectedImage} alt="Selected" required />
                          )}
                          <label
                            htmlFor="file"
                            className="editprofileicon"
                            name="file"
                            onChange={handleFileChange}
                            required
                          >
                            <icons.Pencil />
                            <Form.Control
                              type="file"
                              id="file"
                              multiple=""
                              data-original-title="upload photos"
                              required
                            />
                          </label>
                        </div>
                      )}
                      <p className="mt-2 image-upload-mess">
                        (jpeg, jpg, png and size up to 2 mb)
                        <span className="text-danger">*</span>
                      </p>
                    </div>
                  </Col>
                  <Col md={7} className="border-custom profile-form-sec">
                    <Row className="mb-3">
                      <Form.Group
                        as={Col}
                        md="6 mt-3"
                        controlId="validationCustom02"
                      >
                        <Form.Label>First Name</Form.Label>
                        <Form.Control
                          onChange={handelform}
                          name="firstName"
                          value={regForm?.firstName}
                          required
                          maxLength="30"
                          type="text"
                          placeholder="Enter your first name"
                          onKeyPress={(e) => {
                            if (e.key === "Enter") e.preventDefault();
                          }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please enter First Name.
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="6 mt-3"
                        controlId="validationCustomUsername"
                      >
                        <Form.Label>Last Name</Form.Label>
                        <InputGroup hasValidation>
                          <Form.Control
                            type="text"
                            onChange={handelform}
                            name="lastName"
                            maxLength="30"
                            value={regForm?.lastName}
                            placeholder="Enter your last name"
                            aria-describedby="inputGroupPrepend"
                            onKeyPress={(e) => {
                              if (e.key === "Enter") e.preventDefault();
                            }}
                          />
                        </InputGroup>
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="6 mt-3"
                        controlId="formDateOfBirth"
                      >
                        <Form.Label>Date of Birth</Form.Label>
                        <DatePicker
                          placeholder="Select Date of Birth"
                          shouldDisableDate={shouldDisableDate}
                          format="MMM dd,yyyy"
                          value={dateBirth}
                          name="dateOfBirth"
                          className="Auction-Date"
                          onChange={handelDate}
                          required
                        />
                        <Form.Control.Feedback
                          type="invalid"
                          show={validated && !dateBirth}
                        >
                          Please enter Date of birth.
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group as={Col} md="6 mt-3" className="text-left">
                        <Form.Label>Gender</Form.Label>
                        <InputGroup hasValidation>
                          <Form.Select
                            onChange={handelGender}
                            name="gender"
                            value={regForm?.gender}
                            className="select-option"
                            required
                            as="select"
                          >
                            <option value={""}>Select Gender</option>
                            <option value={"M"}>Male</option>
                            <option value={"F"}>Female</option>
                            <option value={"O"}>Other</option>
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            Please select a Gender.
                          </Form.Control.Feedback>
                        </InputGroup>
                      </Form.Group>
                      <Form.Group as={Col} md="6 mt-3">
                        <Form.Label>Phone Number</Form.Label>
                        <div className="d-flex group-ph">
                          <PhoneInput
                            type="text"
                            international
                            value={countryCode}
                            onChange={handelPhoneCountryCode}
                            flags={flags}
                            defaultCountry="US"
                            countryCallingCodeEditable={false}
                          />
                          <Form.Control
                            type="text"
                            maxLength="10"
                            onKeyDown={handleKeypress}
                            className="phone-number-input"
                            pattern="[1-9]{1}[0-9]{9}"
                            onChange={handelform}
                            name="phoneNumber"
                            value={formattedNumber}
                            placeholder="Enter your phone number"
                            required
                          />
                        </div>
                        <Form.Control.Feedback type="invalid">
                          Please enter phone number.
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group as={Col} md="6 mt-3">
                        <Form.Label>Email/User Id</Form.Label>
                        <Form.Control
                          type="email"
                          value={regForm?.emailId}
                          disabled
                          placeholder="Enter your email"
                          required
                        />
                        <Form.Control.Feedback type="invalid">
                          Please enter Email.
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group as={Col} md="12 mt-3">
                        <Form.Label>Address</Form.Label>
                        <Form.Control
                          type="text"
                          onChange={handelform}
                          name="address"
                          value={regForm?.address}
                          placeholder="Enter your Address"
                          required
                        />
                        <Form.Control.Feedback type="invalid">
                          Please enter Address.
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="6 mt-3"
                        className="text-left"
                        controlId="validationCustomCountry"
                      >
                        <Form.Label>Country</Form.Label>
                        <InputGroup hasValidation>
                          <Form.Control
                            type="text"
                            onChange={handelform}
                            name="country"
                            value={location?.country || regForm?.country}
                            placeholder="Enter your Country"
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter a Country.
                          </Form.Control.Feedback>
                        </InputGroup>
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="6 mt-3"
                        className="text-left"
                        controlId="validationCustomState"
                      >
                        <Form.Label>State</Form.Label>
                        <InputGroup hasValidation>
                          <Form.Control
                            type="text"
                            onChange={handelform}
                            name="state"
                            value={
                              location?.["places"]?.[0]?.state || regForm?.state
                            }
                            placeholder="Enter your State/Province"
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter a State/Province.
                          </Form.Control.Feedback>
                        </InputGroup>
                      </Form.Group>
                      <Form.Group as={Col} md="6 mt-3" className="text-left">
                        <Form.Label>City</Form.Label>
                        <InputGroup hasValidation>
                          <Form.Control
                            type="text"
                            onChange={handelform}
                            name="city"
                            value={
                              location?.["places"]?.[0]?.["place name"] ||
                              regForm?.city
                            }
                            placeholder="Enter your City"
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter a City name.
                          </Form.Control.Feedback>
                        </InputGroup>
                      </Form.Group>
                      <Form.Group as={Col} md="6 mt-3">
                        <Form.Label>Zip/Province Code</Form.Label>
                        <Form.Control
                          type="text"
                          minLength={3}
                          maxLength="5"
                          onChange={handelZipCode}
                          name="zipCode"
                          value={regForm?.zipCode === 0 ? "" : regForm?.zipCode}
                          placeholder="Enter your Zip Code"
                          required
                        />
                        <Form.Control.Feedback type="invalid">
                          Please enter Zip Code.
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Row>
                    <button
                      type="button"
                      className="cancel-btn mt-3"
                      onClick={cancelbtn}
                    >
                      Cancel
                    </button>
                    <Button type="submit" className="update-btn-prof">
                      Update
                    </Button>
                  </Col>
                </Row>
              </Form>
            )}
          </Card>
        </div>
        <div className={data ? "footer" : "footer-content"}>
          <Footer />
        </div>
      </div>
    </>
  );
};
